/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Sources_BodyInputs */



/**
* | output |
* | --- |
* | "Wundo reads this while preparing and writing up this conversation." |
*
* @param {Meeting_Sources_BodyInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_sources_body = /** @type {((inputs?: Meeting_Sources_BodyInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Sources_BodyInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Dit leest Wundo mee bij de voorbereiding en het verslag van dit gesprek.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Wundo lit ceci pour la préparation et le compte rendu de cette conversation.")
	return /** @type {LocalizedString} */ ("Wundo reads this while preparing and writing up this conversation.")
});